/** @module Classes */ /** typedoc */
import { keys } from 'ts-transformer-keys';
import { AccountGlobalStatusEnum, AccountingStatusEnum, ServiceStatusEnum } from '../../enums/billing';
import { Price } from '../Price';
import { HasOverduePayment } from './HasOverduePayment';

export class AccountStatus {
    /**
     * Direct mapping of backend status
     * Note: this is not used by webapp but it's still available in case we need a more granular status
     */
    public accountingStatus: AccountingStatusEnum = null;

    /**
     * The current user balance. Positive if user has money, negative if the user Owns money to LANDR
     */
    public balance: Price = null;

    /**
     * the amount of the debt owed by the user. always positive or 0 if no debt.
     */
    public debt: Price = null;

    /**
     * the amount of the credit accumulated by the user. always positive or 0 if no credit.
     */
    public credit: Price = null;

    /**
     * Aggregation of `serviceStatus` and `accountingStatus`.
     * Right now webapp only uses this global status.
     * But if we need more detail, `serviceStatus` and `accountStatus` is here to get more detail.
     * Note: only `globalStatus` is used by the webapp for now
     */
    public globalStatus: AccountGlobalStatusEnum = null;

    /**
     * Direct mapping of backend status
     * Note: this is not used by webapp but it's still available in case we need a more granular status
     */
    public serviceStatus: ServiceStatusEnum = null;

    /**
     * Shows which service offers for which a user has overdue payments
     */
    public hasOverduePayment: HasOverduePayment = null;
}

export const keysOfAccountStatus: Array<keyof AccountStatus> = keys<AccountStatus>();
